import { makeAutoObservable } from "mobx";
import { apiPostPut, apiGet } from "../api/api_methods";

class InterviewStore {
  loading = false;
  chatHistory = [];
  userVoiceInput = ""; // this is the setence after backspace
  transcript = "";
  compilerCode = "";
  botCC = "";
  redirectUrl = "";
  screenRecorder = null;
  recordingTime = null;
  showMessageTab = false;
  lastSubmitTimeStamp = Math.floor(Date.now() / 1000);
  autoMicOffStamp = 99999999999;
  voiceSlang = process.env.REACT_APP_AZURE_VOICE_KEY;
  speechResult = [];
  companieslist = [];
  UserMSGError = false;
  tabSwitchCount = 0;
  turnOffCamera = false;
  recordPermission = false;
  isVideoUploaded = false;
  isInterviewStarted = false;
  voiceVisualizer = false;
  userPic = "";
  interviewId = "";
  setInterviewId = (id) => {
    this.interviewId = id;
  };
  setVoiceVisualizer = (state) => {
    this.voiceVisualizer = state;
  };
  setIsInterviewStarted = (state) => {
    this.isInterviewStarted = state;
  };
  setIsVideoUploaded = (state) => {
    this.isVideoUploaded = state;
  };
  setRecordPermission = (state) => {
    this.recordPermission = state;
  };
  setTurnOffCamera = (state) => {
    this.turnOffCamera = state;
  };
  setTabSwitchCount = (count) => {
    this.tabSwitchCount = count;
  };
  interviewModal = 1;
  whoPay = false;
  setUserMSGError = (state) => {
    this.UserMSGError = state;
  };

  interviewDetails = {};
  presentInterviewDetails = {};

  // interivew states
  micState = false;
  speaking = false;

  forceStopMic = false;
  micToggled = false;

  isUserSpeaking = false; // this is the state of the user speaking or not in mobile view

  companyName = null;
  companyurl = null;
  role = null;

  interviewSettings = {};
  resumeFile = null;
  resumeText = null; // this the extracted text from the resume

  // this is the states to show or hide the interview settings modal
  showName = true;
  showTechnology = false;
  showRole = false;
  showNoOfQuestions = false;
  showInterviewLevel = false;
  showResume = false;
  showCompany = false;
  showCompanyUrl = false;
  askHaveResume = false;
  whoPayValue = "company";

  selectedAudio = {
    id: 3,
    country: "US",
    gender: "Female",
    label: "Lucy",
    voice: "en-US-ElizabethNeural",
    image: "/static/media/Lucy.c84f2fcccfbac866db17.png",
  };
  notificationText = "";
  notificationIcon = "";
  nottificationTimer = false;
  showNotification = false;
  noiseCancellation = true;
  micNotification = false;
  cameraNotification = false;
  isInterviewCompleted = false;

  previousInterviewsList = [];
  interviewNavigationLink = "";
  isAttemptLeft = true;

  sttModule = "azure-stt";
  ttsModule = "azure-tts";

  setTtsModule = (module) => {
    this.ttsModule = module;
  };

  setSttModule = (module) => {
    this.sttModule = module;
  };

  setSelectedAudio = (audio) => {
    this.selectedAudio = audio;
  };
  setAttemptLeft = (state) => {
    this.isAttemptLeft = state;
  };
  setInterviewNavigationLink = (link) => {
    this.interviewNavigationLink = link;
  };
  setPreviousInterviewsList = (value) => {
    this.previousInterviewsList = value;
  };

  setNoiseCancellation = (state) => {
    this.noiseCancellation = state;
  };

  setUserPic = (pic) => {
    this.userPic = pic;
  };

  VideoUpload = false;
  setVideoUpload = (state) => {
    this.VideoUpload = state;
  };

  VideoUploadProgress = 0;
  setVideoUploadProgress = (progress) => {
    this.VideoUploadProgress = progress;
  };

  // custome question for interview creation
  customQuestions = [];

  showCustomQuestions = false;

  maskingFields = [];

  additionalSettings = {
    camera: false,
    screen: false,
    resume: false,
    attempts: 2,
  };

  ResumeCompanyInterview = true;
  fullScreen = false;
  azureVoice = process.env.REACT_APP_AZURE_VOICE === "true"; // this is the state of the azure voice

  textRestriction = false;

  setNotificationText = (text) => {
    this.notificationText = text;
  };

  setNotificationIcon = (icon) => {
    this.notificationIcon = icon;
  };

  setNotificationTimer = (state) => {
    this.nottificationTimer = state;
  };

  setShowNotification = (state) => {
    this.showNotification = state;
  };

  setMicNotification = (state) => {
    this.micNotification = state;
  };

  setCameraNotification = (state) => {
    this.cameraNotification = state;
  };

  setIsInterviewCompleted = (state) => {
    this.isInterviewCompleted = state;
  };

  setTextRestriction = (state) => {
    this.textRestriction = state;
  };

  setFullScreen = (state) => {
    this.fullScreen = state;
  };

  setRedirectUrl = (value) => {
    this.redirectUrl = value;
  };

  setResumeCompanyInterview = (state) => {
    this.ResumeCompanyInterview = state;
  };

  setAdditionalSettings = (id, settings) => {
    this.additionalSettings[id] = settings;
  };

  companyInterview = false;
  setCompanyInterview = (state) => {
    this.companyInterview = state;
  };
  validation = false;
  setValidation = (state) => {
    this.validation = state;
  };

  setDefaultMaskingFields = () => {
    this.maskingFields = [
      "technology",
      "noOfQuestions",
      "askHaveResume",
      "interviewLevel",
    ];
  };

  setWhoPay = (value) => {
    this.whoPay = value;
  };

  setWhoPayValue = (value) => {
    this.whoPayValue = value;
  };

  resetMaskingFields = () => {
    this.maskingFields = [];
  };

  setCustomQuestions = (questions) => {
    this.customQuestions = questions;
  };

  setShowCustomQuestions = (state) => {
    this.showCustomQuestions = state ?? true;
  };

  enableBasicMockInterview = (role) => {
    this.showTechnology = true;
    this.showNoOfQuestions = true;
    this.showInterviewLevel = true;
    this.askHaveResume = true;

    switch (role) {
      case "company":
      case "consultancy":
        this.showName = false;
        this.askHaveResume = false;

        break;

      default:
        break;
    }
  };
  enableVivaInterview = (role) => {
    this.showTechnology = true;
    this.showNoOfQuestions = true;
    this.showInterviewLevel = true;
  };

  enableResumeMockInterview = (role) => {
    this.showTechnology = true;
    this.showNoOfQuestions = true;
    this.showInterviewLevel = true;
    this.showResume = true;
    this.askHaveResume = true;

    // switch (role) {
    //   case "company":
    //   case "consultancy":
    //     this.showName = false;
    //     this.askHaveResume = false;
    //     this.showResume = false;

    //     break;

    //   default:
    //     break;
    // }
  };

  enableCompanyMockInterview = (role) => {
    this.showNoOfQuestions = true;
    this.showInterviewLevel = true;
    this.showCompany = true;
    this.showCompanyUrl = true;
    this.showRole = true;
    this.askHaveResume = true;
  };

  enableTechnicalManualInterview = (role) => {
    this.showName = true;
    this.showTechnology = true;
    this.showNoOfQuestions = true;
    this.showCustomQuestions = true;
    this.askHaveResume = true;
    this.showResume = true;
    // switch (role) {
    //   case "company":
    //   case "consultancy":
    //     this.showName = false;
    //     this.askHaveResume = false;
    //     this.showResume = false;
    //     break;
    //   default:
    //     break;
    // }
  };

  enableHRManualInterview = (role) => {
    this.showName = true;
    this.showNoOfQuestions = true;
    this.showCustomQuestions = true;
    this.askHaveResume = true;
    this.showResume = true;
    // switch (role) {
    //   case "company":
    //   case "consultancy":
    //     this.showName = false;
    //     this.askHaveResume = false;
    //     this.showResume = false;
    //     break;
    //   default:
    //     break;
    // }
  };

  enableCompnayResumeMockInterview = (role) => {
    this.showNoOfQuestions = true;
    this.showInterviewLevel = true;
    this.showCompany = true;
    this.showRole = true;
    this.showResume = true;
    this.askHaveResume = true;
  };

  enableEnglishPracticeInterview = (role) => {
    this.showInterviewLevel = true;
  };

  enableHrInterview = (role) => {
    this.showInterviewLevel = true;
    this.askHaveResume = true;
    switch (role) {
      case "company":
      case "consultancy":
        this.showName = false;
        this.askHaveResume = false;

        break;

      default:
        break;
    }
  };

  handleStatusChange = async (id, status) => {
    const response = await apiPostPut(
      { status: status },
      `/interview/change-interviewee-status/${id}`,
      "PUT"
    );
    if (response.status === 200) {
      return response.body;
    } else {
      return response.body;
    }
  };

  enableHrInterviewWithResume = (role) => {
    this.showInterviewLevel = true;
    this.askHaveResume = true;
    this.showResume = true;
    this.showNoOfQuestions = true;
    // switch (role) {
    //   case "company":
    //   case "consultancy":
    //     this.showName = false;
    //     this.askHaveResume = false;
    //     this.showResume = false;

    //     break;

    //   default:
    //     break;
    // }
  };

  resetInterviewFields = () => {
    this.showTechnology = false;
    this.showRole = false;
    this.showNoOfQuestions = false;
    this.showInterviewLevel = false;
    this.showResume = false;
    this.showCompany = false;
    this.askHaveResume = false;
    this.resetMaskingFields();
    // this.showCustomQuestions = false;
  };

  setShowResume = (state) => {
    this.showResume = state ?? true;
  };

  changeInterviewIdByIdForResume = (id) => {
    switch (id) {
      case 8: // 8 is the id of hr interview with resume
        this.updateInterviewDetails({ id: 5, interviewId: 5 }); // 5 is the id of hr interview without resume
        break;
      case 5:
        this.updateInterviewDetails({ id: 8, interviewId: 8 });
        break;
      case 1:
        this.updateInterviewDetails({ id: 2, interviewId: 2 });
        break;
      case 2:
        this.updateInterviewDetails({ id: 1, interviewId: 1 });
        break;
      case 3:
        this.updateInterviewDetails({ id: 4, interviewId: 4 });
        break;

      case 4:
        this.updateInterviewDetails({ id: 3, interviewId: 3 });
        break;

      default:
        break;
    }
  };

  enableInterviewFormById = (id, role) => {
    console.log(id);
    switch (id) {
      case 1:
        this.enableBasicMockInterview(role);
        break;
      case 2:
        this.enableResumeMockInterview(role);
        break;
      case 3:
        this.enableCompanyMockInterview(role);
        break;
      case 4:
        this.enableCompnayResumeMockInterview(role);
        break;

      case 5:
        this.enableHrInterview(role);
        break;
      case 6:
        this.enableEnglishPracticeInterview(role);
        break;
      case 7:
        this.enableBasicMockInterview(role);
        break;
      case 8:
        this.enableHrInterviewWithResume(role);
        break;

      case 9:
        this.enableVivaInterview(role);
        break;

      case 10:
        this.enableResumeMockInterview(role);
        break;

      case 11:
        this.enableHRManualInterview(role);
        break;

      case 12:
        this.enableTechnicalManualInterview(role);
        break;

      default:
        this.resetInterviewFields(role);
        break;
    }
  };

  setInterviewSettings = (setting) => {
    this.interviewSettings = setting;
  };

  setResumeText = (text) => {
    this.resumeText = text;
  };

  setResumeFile = (file) => {
    this.resumeFile = file;
  };

  setInterviewDetails = (Detail) => {
    this.interviewSettings = Detail;
    localStorage.setItem(
      "interviewDetails",
      JSON.stringify(this.interviewSettings)
    );
    localStorage.setItem(
      "interviewSettings",
      JSON.stringify(this.interviewSettings)
    );
  };

  setPresentInterviewDetails = (Details) => {
    this.presentInterviewDetails = Details;
  };

  updateInterviewDetails = (Detail) => {
    this.interviewSettings = { ...this.interviewSettings, ...Detail };
    localStorage.setItem(
      "interviewDetails",
      JSON.stringify(this.interviewSettings)
    );
    localStorage.setItem(
      "interviewSettings",
      JSON.stringify(this.interviewSettings)
    );
  };

  setCompilerCode = (code) => {
    this.compilerCode = code;
  };

  setCompanyName = (name) => {
    this.companyName = name;
  };

  setRole = (role) => {
    this.role = role;
  };

  setCompaniesList = (list) => {
    this.companieslist = list;
  };

  setIsUserSpeaking = (state) => {
    this.isUserSpeaking = state;
  };

  setInterviewModal = (modal) => {
    this.interviewModal = modal;
  };

  geetingCompanyBasedInterviewData = async () => {
    const response = await apiGet(`/mock/get/5`);
    if (response.status === 200) {
      console.log(response?.body?.data);
      return this.setCompaniesList(response?.body?.data);
    }
    return alert("failed to fetch");
  };

  updateProxyByInterviewId = async (interviewId, data) => {
    const response = await apiPostPut(
      data,
      `/new-proxy/update-proxy-by-interview-id/${interviewId}`,
      "POST"
    );
    if (response.status === 200) {
      return response?.body?.data;
    }
    return false;
  };

  newProxy = async (interviewId, interviewee) => {
    const response = await apiPostPut(
      {
        interviewId: interviewId,
        interviewee: interviewee,
        snapShots: [
          {
            url: localStorage.getItem("userImage"),
            type: "image",
          },
        ],
      },
      `/new-proxy/create-proxy`,
      "POST"
    );
    localStorage.removeItem("userImage");
    if (response.status === 200) {
      return response?.body?.data;
    }
    return alert("failed to fetch");
  };

  updateProxy = async (interviewId, interviewee) => {
    const response = await apiPostPut(
      {
        snapShots: [
          {
            url: localStorage.getItem("userImage"),
            type: "image",
          },
        ],
      },
      `/new-proxy/update-proxy-by-interview-id/${interviewId}`,
      "POST"
    );
    if (response.status === 200) {
      return response?.body?.data;
    } else if (response.status === 404) {
      return this.newProxy(interviewId, interviewee);
    }
    return console.log("failed to update proxy");
  };

  updateInterviewById = async (_id, body) => {
    const api = `/interview/update-interview/${_id}`;
    const response = await apiPostPut(body, api, "PUT");
    if (response.status === 200) {
      console.log(response?.body?.data);
      return response?.body?.data;
    }
    return alert("failed to update interview");
  };

  updateInterviewCompletedTime = (interviewId) => {
    const completedAt = new Date().valueOf();
    const body = {
      interviewCompletedAt: completedAt,
      isInterviewCompleted: true,
    };
    const api = `/interview/update-interview/${interviewId}`;
    apiPostPut(body, api, "PUT");
  };

  mergeTheTranscript = (clearResult = false) => {
    if (this.speechResult.length === 0) {
      return;
    }
    const finalTranscript =
      this.speechResult[this.speechResult.length - 1].transcript;
    this.userVoiceInput = this.userVoiceInput + " " + finalTranscript;
    if (clearResult) this.speechResult = [];
  };

  setSpeechResult = (result) => {
    this.speechResult = result;
  };

  setMicToggled = (state) => {
    this.micToggled = state;
  };

  setAutoMicOffStamp = (stamp) => {
    this.autoMicOffStamp = stamp ?? Math.floor(Date.now() / 1000);
  };

  setForceStopMic = (state) => {
    this.forceStopMic = state;
  };

  setSpeaking = (state) => {
    this.speaking = state;
  };

  setMicState = (state) => {
    this.micState = state;
  };

  setLastSubmitTimeStamp = (stamp) => {
    // how to create 10 digit timestamp

    const timeStamp = stamp ?? Math.floor(Date.now() / 1000);
    console.log(timeStamp);
    this.lastSubmitTimeStamp = timeStamp;
  };

  constructor() {
    makeAutoObservable(this);
  }

  toggleScreen = (messageTab) => {
    this.showMessageTab = messageTab ?? false;
  };

  setRecordingTime = (val) => {
    this.recordingTime = val ?? "";
  };

  setScreenRecorder = (blob) => {
    this.screenRecorder = blob ?? null;
  };

  setbotCC = (text) => {
    this.botCC = text ?? "";
  };

  setTranscription = (text) => {
    this.transcript = text;
  };

  resetTranscript = () => {
    this.transcript = "";
  };

  setChatHistory = (chat) => {
    this.chatHistory = chat;
  };

  setLoading = (loading) => {
    this.loading = loading;
  };

  backSpace = (clearTranscript) => {
    let totalTranscript = this.transcript
      ? this.userVoiceInput + " " + this.transcript
      : this.userVoiceInput;
    console.log(totalTranscript);
    const transcriptArray = totalTranscript.split(" ");
    transcriptArray.pop();
    const updatedTranscript = transcriptArray.join(" ");
    console.log(updatedTranscript);
    this.userVoiceInput = updatedTranscript;

    if (clearTranscript) {
      this.transcript = "";
    }

    // const transcriptArray = this.userVoiceInput.split(" ");
    // transcriptArray.pop();
    // const updatedTranscript = transcriptArray.join(" ");
    // this.userVoiceInput = updatedTranscript;
    // this.transcript = "";
  };

  appendUserVoiceInput = (text) => {
    this.userVoiceInput = this.userVoiceInput + " " + text;
  };

  setUserVoiceInput = (text) => {
    this.userVoiceInput = text;
  };

  resetUserVoiceInput = () => {
    this.userVoiceInput = "";
  };

  clearTranscriptAndUserVoiceInput = () => {
    this.userVoiceInput = "";
    this.transcript = "";
  };
}

export default InterviewStore;
